import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ClinicalIndustry from "@/pages/ClinicalIndustry";

export const Route = createFileRoute("/zh-cn/services/full-service-medical-device-cro")({
  head: () => buildRouteHead("/zh-cn/services/full-service-medical-device-cro", {
      title: "全流程医疗器械 CRO | QbD Group",
      description: "提供全流程医疗器械 CRO 服务：临床策略、研究运营、监查、数据管理以及符合 MDR 与 IVDR 的法规报告。",
    }),
  component: ClinicalIndustry,
});

